<div class="nexleader-onboarding-button-container">
  <a class="nexleader-contact-button" (click)="openHelpModal()">Need help?</a>
  <a class="nexleader-logout-button" *ngIf="isLoggedIn()" (click)="logout()"
    >Logout</a
  >
</div>
